import { modalPaths } from "../../routers";

const matchesPath = (path, pathname) => pathname === path;

export const isNavItemActive = (item, pathname) => {
  if (item.divider || item.external || !item.path) return false;
  if (item.key === "browse") {
    return pathname === "/" || matchesPath("/browse", pathname); // default path routes to browse
  }

  return matchesPath(item.path, pathname);
};

export const isNestedLinkActive = (link, pathname) =>
  matchesPath(link.path, pathname);

export const isNavSectionOpen = (item, pathname) => {
  // nav section is open if we're on that path or one of it's nested paths
  if (!item.nestedLinks) return false;

  return (
    isNavItemActive(item, pathname) ||
    item.nestedLinks.some(link => isNestedLinkActive(link, pathname))
  );
};

// links that open an auth modal must carry the current location in the background
export const getModalLinkState = location => ({
  background: modalPaths.includes(location.pathname)
    ? location.state?.background
    : location
});
